<!-- 资源库 -->
<template>
    <div class="page pageRes">

        <div class="map-main">

            <div class="page-operate">
                <div class="operate-left">
                    <el-button class="btn-upload" @click="uploadFiles" type="primary" size="mini">
                        <i class="nucfont inuc-upload"></i> {{ $t('res.upload') }}
                    </el-button>

                    <el-button class="btn-folder" @click="createFolder" size="mini">
                        <i class="nucfont inuc-folder"></i> {{ $t('res.newFolder') }}
                    </el-button>

                    <el-button-group v-show="selectFiles.length">
                        <!-- 复制到 -->
                        <el-button @click="moveFile(1)" size="mini">
                            <i class="nucfont inuc-copy"></i>
                            <span class="text">{{ $t('res.copyTo') }}</span>
                        </el-button>

                        <!-- 移动到 -->
                        <el-button @click="moveFile(2)" size="mini">
                            <i class="nucfont inuc-move"></i>
                            <span class="text">{{ $t('res.moveTo') }}</span>
                        </el-button>

                        <!-- 重命名 -->
                        <el-button @click="renameFile" :disabled="selectFiles.length>1" size="mini">
                            <i class="nucfont inuc-fuxun"></i>
                            <span class="text">{{ $t('res.rename') }}</span>
                        </el-button>

                        <!-- 删除 -->
                        <el-button @click="deleteFile" size="mini">
                            <i class="nucfont inuc-delete"></i>
                            <span class="text">{{ $t('c.delete') }}</span>
                        </el-button>
                    </el-button-group>

                    <el-button v-show="selectFiles.length" class="btn-cancel" @click="resetSelect" size="mini">
                        {{ $t('c.cancel') }}
                    </el-button>
                </div>

                <div class="operate-right">
                    <el-select v-model="fileType"
                               class="filter-type"
                               ref="fileTree"
                               :placeholder="$t('tip.select')" @change="selectChange" size="small">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>

                    <el-input class="filter-name" v-model="fileName"
                              @keyup.enter.native="queryResource(1)"
                              :placeholder="$t('tip.name')" size="small" clearable>
                        <el-button slot="append" @click="queryResource(1)" icon="el-icon-search"></el-button>
                    </el-input>

                    <div class="switch-style">
                        <a class="switch-style-btn" @click="menuStyle=1" :class="{'active':menuStyle===1}">
                            <i class="nucfont inuc-menu-grid"></i>
                        </a>
                        <a class="switch-style-btn" @click="menuStyle=2" :class="{'active':menuStyle===2}">
                            <i class="nucfont inuc-menu-assemble"></i>
                        </a>
                    </div>
                </div>
            </div>

            <div class="file-path">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item v-for="(item, i) in realList" :key="item.id"><a
                        @click="backFile(item, i)"><span>{{ item == '' ? $t('res.allFiles') : item }}</span></a>
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="total"> {{$t('res.fileTotal', [pagTotal])}} </div>
            </div>

            <div class="file-header">
                <div class="select-all">
                    <el-checkbox v-model="checkAll" @change="checkAllChange">
                        <span v-if="selectFiles.length"> {{$t('res.selected', [selectFiles.length])}} </span>
                        <span v-else>{{ $t('res.checkAll') }}</span>
                    </el-checkbox>
                </div>
            </div>

            <div class="map-list-box"  v-loading="listLoading">
                <div class="selection" @mouseup="fixClick2"></div>

                <div class="map-list"
                     :class="menuStyle===1?'map-list-thumb':'map-list-cell'"
                     id="map-list"
                     @contextmenu.prevent="$refs.blankMenu.open($event)"
                     v-selectable="{
                         selectedGetter: selectedGetter,
                          selectedSetter: selectedSetter,
                          selectingSetter: selectingSetter,
                     }"
                     ref="selectableTable"
                >

                    <!-- 文件视图 .map-list-thumb -->
                    <template v-if="menuStyle === 1">
                        <el-checkbox-group v-model="selectFiles" @change="selectFileChange">
                            <transition-group tag="ul" class="map-list-thumb-ul images clearfix"
                                              v-viewer="{movable: true,filter(image) {if(image.className.indexOf('img-click-disabled') < 0) return true; }}">

                                <li class="map-list-thumb-li selectable" v-for="(item, i) in listData" :key="item.id"
                                    @contextmenu.prevent.stop="$refs.fileMenu.open($event, item)"
                                    :class="{
                                             'selected': selected[i],
                                             'selecting': selecting[i]
                                        }"
                                    :title="item.name">

                                    <div class="map-item"
                                         :class="{
                                            'div-click-disabled':item.status!==2,
                                            'checked': selectFiles.includes(item.id),
                                        }">
                                        <el-checkbox :label="item.id"
                                                     @click.native.stop
                                                     @mousedown.native.stop
                                        >{{ }}</el-checkbox>
                                        <div class="checked-bg"></div>
                                        <!-- 文件夹 -->
                                        <div class="file-thumb" v-if="item.type==21" @click="openFile(item, $event)" @mousedown="fixClick1(item, $event)">
                                            <div class="folder thumb"></div>
                                        </div>
                                        <!-- 图片 -->
                                        <div class="file-thumb" v-if="item.type==12" @click="openFile(item, $event)" @mousedown="fixClick1(item, $event)">
                                            <div class="img-wrap thumb">
                                                <img class="map-item-img" :src="item.thumbnail"
                                                     :alt="item.id" :class="{'img-click-disabled':item.status!=2}">
                                            </div>
                                        </div>
                                        <!-- 视频 -->
                                        <div class="file-thumb" v-if="item.type==10" @click="openFile(item, $event)" @mousedown="fixClick1(item, $event)">
                                            <div class="res-video thumb"></div>
                                        </div>
                                        <!-- 音频 -->
                                        <div class="file-thumb" v-if="item.type==11" @click="openFile(item, $event)" @mousedown="fixClick1(item, $event)">
                                            <div class="res-audio thumb"></div>
                                        </div>
                                        <!-- 文档 -->
                                        <div class="file-thumb" v-if="item.type==8" @click="openFile(item, $event)" @mousedown="fixClick1(item, $event)">
                                            <a>
                                                <div class="res-document-excel thumb"
                                                     v-if="item.extension=='.xls'||item.extension=='.xlsx'"></div>
                                                <div class="res-document-pdf thumb" v-else-if="item.extension=='.pdf'"></div>
                                                <div class="res-document-ppt thumb"
                                                     v-else-if="item.extension=='.ppt'||item.extension=='.pptx'"></div>
                                                <div class="res-document-txt thumb" v-else-if="item.extension=='.txt'"></div>
                                                <div class="res-document-word thumb"
                                                     v-else-if="item.extension=='.doc'||item.extension=='.docx'"></div>
                                                <div class="res-document-undefined thumb" v-else></div>
                                            </a>
                                        </div>

                                        <p class="map-item-name" @click="openFile(item, $event)"  @mousedown.stop :data-name="item.name">{{ item.name }}</p>
                                        <p class="map-item-size" v-if="item.type!==21">{{ item.length | formatFileSize }}</p>
                                    </div>
                                </li>

                            </transition-group>
                        </el-checkbox-group>
                        <span v-show="!pagTotal" class="emptyBox">
                                 {{ $t('c.noData') }}
                        </span>
                    </template>

                    <!-- 列表视图 .map-list-cell -->
                    <template v-else>
                        <ul class="cell-title">
                            <li class="info">{{ $t('res.file') }}</li>
                            <li class="size">{{ $t('res.fileSize') }}</li>
                            <li class="date">{{ $t('c.modificationTime') }}</li>
                        </ul>
                        <el-checkbox-group v-model="selectFiles" @change="selectFileChange"
                                           style="overflow-y: auto;height: 95%">
                            <transition-group tag="ul" class="map-list-cell-ul images clearfix"
                                              v-viewer="{movable: true,filter(image) {if(image.className.indexOf('img-click-disabled') < 0) return true; }}">

                                <li class="map-item-cell selectable" v-for="(item, i) in listData" :key="item.id"
                                    :class="{
                                             'selected': selected[i],
                                             'selecting': selecting[i],
                                             'checked': selectFiles.includes(item.id),
                                        }"
                                    @contextmenu.prevent.stop="$refs.fileMenu.open($event, item)">

                                    <div class="info">
                                        <el-checkbox @click.native.stop
                                                     @mousedown.native.stop
                                                     :label="item.id">{{ }}</el-checkbox>
                                        <div class="cell-thumb" v-if="item.type==21">
                                            <div class="folder thumb"></div>
                                        </div>
                                        <div class="cell-thumb" v-if="item.type==12">
                                            <img class="map-item-img" :src="item.thumbnail" :alt="item.id"
                                                 :class="{'img-click-disabled':item.status!=2}">
                                        </div>
                                        <div class="cell-thumb" v-if="item.type==10">
                                            <div class="res-video thumb"></div>
                                        </div>
                                        <div class="cell-thumb" v-if="item.type==11">
                                            <div class="res-audio thumb"></div>
                                        </div>
                                        <div class="cell-thumb" v-if="item.type==8">
                                            <a>
                                                <div class="res-document-excel thumb"
                                                     v-if="item.extension=='.xls'||item.extension=='.xlsx'"></div>
                                                <div class="res-document-pdf thumb" v-else-if="item.extension=='.pdf'"></div>
                                                <div class="res-document-ppt thumb"
                                                     v-else-if="item.extension=='.ppt'||item.extension=='.pptx'"></div>
                                                <div class="res-document-txt thumb" v-else-if="item.extension=='.txt'"></div>
                                                <div class="res-document-word thumb"
                                                     v-else-if="item.extension=='.doc'||item.extension=='.docx'"></div>
                                                <div class="res-document-undefined thumb" v-else></div>
                                            </a>
                                        </div>

                                        <span class="map-item-name"
                                              @click.stop="openFile(item, $event)"
                                              @mousedown="fixClick1(item, $event)"
                                              :class="{'div-click-disabled':item.status!=2}"
                                              :data-name="item.name">
                                            {{ item.name }}
                                        </span>
                                    </div>

                                    <div class="size">
                                        <template v-if="item.type===21"></template>
                                        <template v-else>{{ item.length | formatFileSize }}</template>
                                    </div>
                                    <div class="date">{{ item.createTime | datetime }}</div>
                                </li>
                            </transition-group>
                        </el-checkbox-group>
                        <span v-show="!pagTotal" class="emptyBox">{{ $t('c.noData') }}</span>
                    </template>
                </div>
            </div>

            <div class="pagination-bar">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout="total, prev, pager, next, jumper"
                    :total="pagTotal"
                    :page-size="pageSize">
                </el-pagination>
            </div>

        </div>

        <file-move
            v-model="fileMoveDialog"
            :type="fileMoveType"
            :ids="selectFiles"
            @move-success="moveFileSuccess"
        ></file-move>

        <context-menu ref="fileMenu"
                      class="right-menu"
                      @contextmenu.native.prevent
                      @ctx-open="onFileMenuOpen">
            <li @click="moveFile(1)"><a><i class="nucfont inuc-copy"></i>{{ $t('res.copyTo') }}(C)</a></li>
            <li @click="moveFile(2)"><a><i class="nucfont inuc-move"></i>{{ $t('res.moveTo') }}(X)</a></li>
            <li @click="renameFile"><a><i class="nucfont inuc-fuxun"></i>{{ $t('res.rename') }}</a></li>
            <li @click="deleteFile"><a><i class="nucfont inuc-delete"></i>{{ $t('c.delete') }}(D)</a></li>
        </context-menu>

        <context-menu ref="blankMenu"
                      class="right-menu"
                      @contextmenu.native.prevent
                      @ctx-open="onBlankMenuOpen">
            <li @click="createFolder"><a><i class="nucfont inuc-folder"></i>{{ $t('res.newFolder') }}</a></li>
            <li @click="uploadFiles"><a><i class="nucfont inuc-upload"></i>{{ $t('res.upload') }}</a></li>
            <li @click="refreshFiles"><a><i class="nucfont inuc-reset"></i>{{ $t('res.refresh') }}</a></li>
        </context-menu>

        <transition
            enter-active-class="animated zoomInRight"
            leave-active-class="animated zoomOutUp"
        >
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
/**
 * todo:排序功能
 */
import {Ticket, Throttle} from '@/utils';
import Bus from '@/utils/bus';
// https://github.com/vmaimone/vue-context-menu
import contextMenu from 'vue-context-menu'
import FileMove from "./Components/FileMove";
import VueSelectable, {setSelectableItems} from '@/plugins/selectable'

export default {
    components: {
        contextMenu,
        FileMove
    },
    directives: {
        selectable: VueSelectable
    },

    data() {
        return {
            listLoading: false,
            checkAll: false,
            superiorID: null,
            menuData: {},
            menuStyle: 1,   // 1网格 2列表

            options: [{
                value: '',
                label: this.$t('c.all')
            }, {
                value: 'Picture',
                label: this.$t('c.image')
            }, {
                value: 'Document',
                label: this.$t('c.document')
            }, {
                value: 'Audio',
                label: this.$t('c.audio')
            }, {
                value: 'Video',
                label: this.$t('c.video')
            },
                // {
                //     value: 'Folder',
                //     label: '文件夹'
                // }
            ],
            fileName: '',
            fileType: '',
            realList: [''],
            realListPath: '',
            listData: [],       // 文件数据
            selectFiles: [],    // 选择的文件
            defaultProps: {
                children: 'children',
                label: 'name'
            },

            pagTotal: 0,
            pageSize: 50,
            currentPage: 1,

            fileMoveDialog: false,
            fileMoveType: 1,

            selected: [],
            selecting: [],
            // 是否正在操作（删除、重命名、复制、移动），防止在某操作时通过快捷键调起其他操作
            isOperating: false,
        };
    },

    mounted() {
        this.queryResource()

        this.bindKeyboard()

        // 在该区域禁掉默认的右键事件
        $('.pageRes .map-list-box').on('contextmenu', () => {
            return false
        })

        Bus.$on('fileSuccess', Throttle(() => {
            this.queryResource()
        }, 500));

        Bus.$on('transcodeSuccess', Throttle(() => {
            this.queryResource()
        }, 500));

    },

    beforeDestroy() {
        this.unbindKeyboard()
    },

    methods: {
        /**
         * [受框选插件影响]
         * 在当前元素上按下鼠标的时候，会先在当前元素上mousedown，然后在 .selection 上mouseup（而不是当前元素，因为框选插件的问题）
         * 因为mousedown和mouseup不是同一个元素，这导致了click失效
         * 所以先把当前点击的元素存起来，等.selection 的mouseup触发后，再手动去调用之前click本该调用的函数
         */
        fixClick1(item, $event) {
            this.clientX = $event.clientX
            this.clientY = $event.clientY
            this.currentItem = item
        },
        fixClick2(e) {
            if (e.clientX === this.clientX && e.clientY === this.clientY) {
                this.openFile(this.currentItem, e)
                setTimeout(() => {
                    this.resetSelect()
                }, 0)
            }
        },

        async queryResource(num, options) {
            if (num) this.currentPage = num

            let queryData = {
                name: this.fileName,
                types: this.fileType,
                path: this.realListPath,
                PageNO: this.currentPage,
                Limit: this.pageSize,
                order: 'Desc',
                ...options
            }

            let res = await this.$api.queryResourceTree(queryData)
            let data = res.package
            this.listData = data;
            this.pagTotal = res.total;

            this.$nextTick(() => {
                setTimeout(() => {
                    setSelectableItems(this.$refs.selectableTable)
                }, 50)
            })

            return data
        },

        uploadFiles() {
            Bus.$emit('openUploader', {
                params: {
                    superiorID: this.superiorID
                }
            })
        },

        createFolder() {
            this.$prompt(this.$t('res.folderNameTip'), this.$t('res.newFolder'), {
                inputValidator: value => {
                    if (!value.trim().length) {
                        return this.$t('res.folderNameTip')
                    }
                    if (value.trim().length > 50) {
                        return this.$t('rule.maxLength', ['50'])
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;

                        this.$api.queryResourceExistFolder({
                            name: instance.inputValue,
                            superiorID: this.superiorID
                        }).then(res => {
                            if (res.result) {
                                done();
                            }
                        }).finally(() => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = this.$t('c.confirm');
                        })
                    } else {
                        done();
                    }
                },
            }).then(({value}) => {

                this.$api.creatResourceFolder({
                    name: value,
                    superiorID: this.superiorID,
                }).then(res => {
                    this.$message.success(this.$t('res.newFolderSuccess'))
                    this.queryResource()
                })

            }).catch(() => {});
        },

        renameFile() {
            let id = this.selectFiles[0]
            let {name, extension, type} = this.listData.find(item => item.id === id)

            this.isOperating = true

            this.$prompt(this.$t('tip.name'), this.$t('res.rename'), {
                inputValue: name,
                inputValidator: value => {
                    if (!value.trim().length) {
                        return this.$t('res.folderNameTip')
                    }
                    if (value.trim().length > 50) {
                        return this.$t('rule.maxLength', ['50'])
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true
                        //instance.confirmButtonText = this.$t('res.progress')

                        let request;
                        let data = {
                            name: instance.inputValue,
                            superiorID: this.superiorID
                        }

                        // 文件夹
                        if (type === 21) {
                            request = this.$api.queryResourceExistFolder
                            // 文件
                        } else {
                            request = this.$api.queryResourceExistFile
                            data.extension = extension
                        }

                        request(data).then(res => {
                            if (res.result) {
                                done();
                            }
                        }).finally(() => {
                            instance.confirmButtonLoading = false;
                            instance.confirmButtonText = this.$t('c.confirm');
                        })
                    } else {
                        done();
                    }

                    this.isOperating = false
                },

            }).then(({value}) => {

                this.$api.reNameResource(id, {name: value}).then(res => {
                    this.$message.success(this.$t('res.renameSuccess'))
                    this.queryResource()
                    this.resetSelect()
                })

            }).catch(() => {})
        },

        async deleteFile() {
            this.isOperating = true

            await this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {type: 'warning'})
                .finally(() => {
                this.isOperating = false
            })

            let ids = this.selectFiles.length ? this.selectFiles : [this.menuData.id]

            await this.$api.deleteResources({ids})

            this.$message.success(this.$t('m.delSuccess'))

            this.queryResource().then(() => {
                this.resetSelect()

                // 如果当前页全删完，则请求上一页
                if (this.listData.length === 0 && this.currentPage > 1) {
                    this.currentPage -= 1;
                    this.queryResource();
                }
            })
        },

        // 移动文件 type：1复制 2移动
        moveFile(type) {
            this.fileMoveDialog = true
            this.fileMoveType = type
            this.isOperating = true
        },
        moveFileSuccess() {
            this.queryResource()
            this.resetSelect()
        },

        resetSelect() {
            this.selectFiles = [];
            this.checkAll = false;
        },
        refreshFiles() {
            this.listLoading = true
            this.queryResource().then(() => {
                setTimeout(() => {
                    this.listLoading = false
                }, 500)
            })
        },

        async openFile(data, e) {
            // 防止误点
            if (e.target.className === 'el-checkbox__original' ||
                e.target.className === 'el-checkbox__inner') return;

            // 转换中的资源
            if (data.status !== 2) return;

            if (data.type === 21) {
                // 文件夹
                this.currentPage = 1;
                this.fileName = '';
                this.realListPath = data.path;
                this.realList = data.path.split('/');
                this.superiorID = data.id;

                await this.queryResource(1)
                this.resetSelect()

            } else if (data.type === 12) {
                // 图片
                const viewer = this.$el.querySelector('.images').$viewer;
                let index = viewer.images.findIndex(ele => ele.alt == data.id);
                viewer.view(index);
            } else {
                this.$router.push({name: 'resDetail', params: {id: data.id}})
            }
        },

        async backFile(path, i) {
            // 当前的路径arr
            let currentPathArr = this.realListPath.split('/')

            // 点击之后的路径arr
            this.realList = currentPathArr.slice(0, i+1)
            this.realListPath = this.realList.join('/')

            this.currentPage = 1;
            this.fileName = '';

            let list = await this.queryResource(1)

            this.resetSelect()
            this.superiorID = list[0].superiorID;
        },

        onFileMenuOpen(locals) {
            this.menuData = locals
            this.$refs.blankMenu.ctxVisible = false
            this.resetSelect()
            this.selectFiles = [locals.id]
        },
        onBlankMenuOpen(locals) {
            this.menuData = locals
            this.$refs.fileMenu.ctxVisible = false
            this.resetSelect()
        },

        checkAllChange(checked) {
            if (checked) {
                let newArr = [];
                this.listData.forEach((element) => {
                    newArr.push(element.id);
                });

                this.selectFiles = newArr;
                this.checkAll = true;
            } else {
                this.selectFiles = [];
                this.checkAll = false
            }
        },

        handleCheckAllChange() {
            if (this.checkAll) {
                this.selectFiles = [];
                this.checkAll = false
            } else {
                let newArr = [];
                this.listData.forEach((element) => {
                    newArr.push(element.id);
                });
                //this.selectFiles = val ? newArr : [];
                this.selectFiles = newArr;
                this.checkAll = true;
            }
        },

        // 页码变化
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryResource();
        },
        selectFileChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.listData.length;
        },
        selectChange() {
            this.currentPage = 1;
            this.fileName = ''
            // this.realListPath = ''
            // this.realList = ['']
            this.queryResource()
        },

        bindKeyboard() {
            $(document).on('keydown.resource', e => {
                let key = e.key.toLowerCase()

                if (this.isOperating) return

                if (['escape','d','x','c'].includes(key)) {
                    this.$refs.fileMenu.ctxVisible = false
                }

                if (key === 'escape') {
                    this.resetSelect()
                }

                if (key === 'd') {
                    if (this.selectFiles.length) this.deleteFile()
                }

                // 移动到
                if (key === 'x') {
                    if (this.selectFiles.length) this.moveFile(2)
                }

                // 复制到
                if (key === 'c') {
                    if (this.selectFiles.length) this.moveFile(1)
                }

            })
        },
        unbindKeyboard() {
            $(document).off('keydown.resource')
        },

        selectedGetter: function () {
            return this.selected
        },

        selectedSetter: function (v) {
            // this.selected = v
            // this.resetSelect()
            // this.listData.forEach((item, i) => {
            //     if (v[i]) {
            //         this.selectFiles.push(item.id)
            //     }
            // })
        },

        selectingSetter: function (v) {
            if (!v.length) return
            this.selecting = v
            this.resetSelect()
            this.listData.forEach((item, i) => {
                if (v[i]) {
                    this.selectFiles.push(item.id)
                }
            })

            this.selectFileChange(this.selectFiles)
        }

    },

}
</script>

<style lang="scss" scoped>
@import '../../style/const.scss';

@include scrollbar();

.pageRes {
    padding: 0;
}

.page-operate {
    display: flex;
    justify-content: space-between;
    padding: 12px 30px 0 30px;
    background-color: #fff;

    .operate-left {
        display: flex;
        align-items: center;

        .el-button-group button,
        .btn-folder {
            &, & i {
                color: #09AAFF;
            }
        }

        .is-disabled {
            &, & i {
                color: #B5E5FF!important;
            }
        }

        .nucfont {
            font-size: 14px;
            margin-right: 4px;
        }
        .el-button-group {
            margin-left: 15px;
            margin-right: 15px;
        }
        .btn-cancel {
            height: 30px;
        }
    }

    .operate-right {
        display: flex;
        align-items: center;
    }

    .btn-folder {
        margin-left: 15px;
    }

    .filter-name {
        width: 15vw;
        min-width: 200px;
        margin-right: 15px;
    }

    .filter-type {
        width: 110px;
        margin-right: 15px;
    }
}

.map-main {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fff;
}

.file-path {
    display: flex;
    padding: 8px 30px;
    .el-breadcrumb {
        flex: 1;
        font-size: 12px;
    }
    .el-breadcrumb__inner a {
        display: inline-block;
        padding: 10px 0;
        color: $blue;
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a {
        color: #606266;
    }
    .total {
        font-size: 12px;
        color: #606266;
    }
}

.file-header {
    padding: 0 30px;
    margin-bottom: 12px;
    .select-all {
        .el-checkbox__label {
            font-size: 13px;
        }
    }
}

.map-list-box {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #ddd;
    min-height: 0;
    user-select: none;

    .emptyBox {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #909399;
    }
}

.map-list {
    position: relative;
    padding: 0 10px;
    flex: 1;
    background-color: #fff;
    overflow-y: auto;

    .thumb {
        background: url(../../assets/images/map/folder.png) center no-repeat;
        background-size: contain;
        &.folder {
            background-image: url(../../assets/images/map/folder.png);
        }
        &.res-video {
            background-image: url(../../assets/images/course/video.png);
        }
        &.res-audio {
            background-image: url(../../assets/images/course/audio.png);
        }
        &.res-document-excel {
            background-image: url(../../assets/images/document/excel.png);
        }
        &.res-document-pdf {
            background-image: url(../../assets/images/document/pdf.png);
        }
        &.res-document-ppt {
            background-image: url(../../assets/images/document/ppt.png);
        }
        &.res-document-txt {
            background-image: url(../../assets/images/document/txt.png);
        }
        &.res-document-word {
            background-image: url(../../assets/images/document/word.png);
        }
        &.res-document-undefined {
            background-image: url(../../assets/images/document/undefined.png);
        }
    }
}

$map-bg: #f1f5fa;
$map-select-border: #90c3fd;

// 略缩图形式
.map-list-thumb {
    padding-left: 30px!important;

    .map-list-thumb-li {
        float: left;
        margin: 5px;
    }

    .map-item {
        position: relative;
        margin: 0 auto;
        width: 124px;
        height: 140px;
        text-align: center;
        border: 1px solid transparent;
        &:hover,
        &.checked {
            border-color: $map-bg;
            background-color: $map-bg;
            border-radius: 5px;

            .el-checkbox {
                display: block;
            }
        }

        .file-thumb {
            display: inline-block;
            margin: 20px auto 0 auto;
            cursor: pointer;
            .thumb {
                position: relative;
                width: 64px;
                height: 64px;
            }
        }

        .img-wrap {
            background: none;

            .map-item-img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .map-item-name {
            padding-top: 10px;
            margin: 0 5px 5px 5px;
            font-size: 13px;
            line-height: 1.4;
            text-align: center;
            @include no-wrap();
            cursor: pointer;
        }

        .map-item-size {
            font-size: 12px;
            color: rgba(26, 39, 52, .4);
            text-align: center;
        }

        .el-checkbox {
            position: absolute;
            display: none;
            top: 0;
            left: 0;
            width: 30px;
            height: 30px;
            margin: 0;
            &:hover {
                transform: scale(1.1);
            }
            /deep/.el-checkbox__input {
                margin: 6px 0 0 6px;
            }

            &.is-checked {
                display: block;

                + .checked-bg {
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    border: 1px solid $map-select-border;
                    background-color: $map-bg;
                    border-radius: 5px;
                    z-index: -1;
                }
            }
        }
    }
}

// 表格形式
.map-list-cell {
    padding-left: 30px;
    overflow: hidden !important;

    .cell-title {
        display: flex;
        margin-top: 0;
        padding-right: 10px;
        height: 36px;
        line-height: 36px;
        border-bottom: 1px solid #f2f6fd;

        > li {
            font-size: 15px;
            color: #4d4d4d;
            font-weight: bold;
        }

        .info {
            padding-left: 70px;
        }
    }

    .info {
        display: flex;
        width: 75%;
    }

    .size,
    .date {
        font-size: 12px;
        color: rgba(26,39,52,.4);
    }

    .size {
        width: 9%;
    }
    .date {
        width: 13%;
    }

    .map-item-cell {
        display: flex;
        height: 56px;
        line-height: 56px;
        padding-left: 10px;
        border-bottom: 1px solid #f2f6fd;

        &:hover, &.checked {
            background-color: #f6faff;
        }
    }

    .map-item-name {
        margin-left: 15px;
        font-size: 14px;
        color: #333;
        cursor: pointer;

        &:hover {
            color: #3b8cff;
        }
    }

    .cell-thumb {
        margin-left: 13px;
        .thumb {
            width: 30px;
            height: 56px;
            vertical-align: top;
        }
    }

    .map-item-img {
        width: 26px;
        height: 28px;
        vertical-align: middle;
        object-fit: contain;
    }
}

.div-click-disabled {
    cursor: not-allowed;

    .file-thumb,
    .map-item-name {
        cursor: not-allowed!important;
    }
}

.pagination-bar {
    padding: 0 30px;
    background-color: #fff;
    /deep/.el-pagination {
        padding-top: 14px;
        padding-bottom: 14px;
    }
}

.switch-style {
    display: flex;
    border: 1px solid #EDEEEF;

    &-btn {
        display: block;
        width: 36px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;

        .nucfont {
            color: #687176;
        }

        &:first-child {
            border-radius: 3px 0 0 3px;
        }

        &:last-child {
            border-radius: 0 3px 3px 0;
        }

        &:hover, &.active {
            background-color: #EEF0FF;

            .nucfont {
                color: #2777FB;
            }
        }
    }
}

.animated {
    -webkit-animation-duration: .3s;
    animation-duration: .3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}
</style>

<style lang="scss">
.pageRes {
    // 右键菜单
    .right-menu {
        border: none;

        .ctx-menu {
            min-width: 110px;
            border-radius: 6px;
            border: none;
            box-shadow: 0 2px 10px rgba(0, 0, 0, .16);

            > li {
                > a {
                    position: relative;
                    display: block;
                    padding: 0 20px 0 44px;
                    height: 38px;
                    line-height: 38px;
                    font-size: 13px;
                    text-align: left;
                    white-space: nowrap;
                    color: #1A2734;
                    cursor: pointer;

                    &:hover {
                        background: $blue;
                        color: #fff;

                        .nucfont {
                            color: #fff;
                        }
                    }
                }

                .nucfont {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 14px;
                    color: #666;
                }
            }
        }
    }

    // 框选插件
    .selection {
        position: absolute;
        border: 1px solid rgb(7, 34, 70);
        background-color: rgb(107, 176, 201);
        opacity: 0.15;
        z-index: 9999;
        top: 0;
        left: 0;
        cursor: default;
        display: none;
    }
    //.selectable.selecting {
    //    background-color: yellow;
    //}
    //.selectable.selected {
    //    background-color: orange;
    //}

    @include media-1280 {
        .operate-left .el-button-group {
            .text {
                display: none;
            }
        }
    }
}
</style>



